const isChinese = Boolean(location.hostname.match("polaxiong"));
const isDevelopment = process.env.NODE_ENV === "development";
const apiHost = isDevelopment ? "api-test" : "api";
const styleHost = isDevelopment ? "styletest" : "s";
const tldPlus1 = isChinese ? "polaxiong.com" : "polarr.co";
const apiEndpoint = `https://${apiHost}.${tldPlus1}/v1`;
const styleEndpoint = `https://${styleHost}.${tldPlus1}`;
const cdnEndpoint = `https://ppe-assets.${tldPlus1}`;
export default {
  apiEndpoint,
  cdnEndpoint,
  staticRoot: process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}static` : "./static",
  styleEndpoint,
  supportedStyleVersion: 3,
};
